import React from 'react';
import { createLazyComponentSilent } from 'utils/lazyLoad';

export default createLazyComponentSilent(() => import('./index'));
